import React, { useCallback, useState, useEffect } from "react";
import {
  Select,
  Divider,
  Form,
  Button,
  Table,
  Space,
  Modal,
  Input,
  message,
  Row,
  Col,
  Upload,
  Result,
} from "antd";
import { store } from "@root/store";
import {
  queryDeleteUserAdmin,
  getAdminTemplate,
  getAdminManageData,
  queryAddCountyAdmin,
  resetPassword,
  queryUpdateCountyAdmin,
} from "@root/common/service";
import { RootState } from "@root/store/index";
import { useSelector } from "react-redux";
import { UploadOutlined } from "@ant-design/icons";
import type { ColumnsType } from "antd/es/table";
import { objectFormatStr } from "@root/common/utils";
import axios from "axios";
const { Option } = Select;
interface DataType {
  baseUserIdCategory: string;
  sex: string;
}
const { NODE_ENV } = process.env;
const prefixpath = NODE_ENV === "development" ? "" : "/county-manager";
export default function AdminManage(props: any) {
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  const { mainFlag } = useSelector((state: RootState) => state.userInfo);
  const [tableTotal, setTableTotal] = useState(1);
  // const [proId, setProId] = useState()
  const [dataSource, setDataSource] = useState<DataType[]>();
  const [addCountyAdmin, setAddCountyAdmin] = useState(false);
  const [fileList, setFileList] = useState<any>([]);
  const [isAddAminUser, setIsAddAdminUser] = useState(true);
  const [adminUserInfo, setAdminUserInfo] = useState<any>({});
  /**
   * 删除管理员用户
   * @param usreId 用户id
   */
  const deleteUserAdmin = async (usreId: number) => {
    await queryDeleteUserAdmin(usreId);
    getAll();
  };
  /**
   * 重置密码
   */
  const resetUserPasword = async (userId: number) => {
    const { code } = await resetPassword({
      userId,
      password: "000000",
    });
    if (code === 200) {
      message.success("重置密码成功，密码为000000");
    }
  };
  const columns: ColumnsType<DataType> = [
    {
      title: "序号",
      render: (text, record, index) => `${index + 1}`,
    },
    {
      title: "姓名",
      dataIndex: "nickName",
      key: "nickName",
    },
    {
      title: "性别",
      dataIndex: "sex",
      key: "sex",
      render: (text, record, index) => (record.sex === "0" ? "男" : "女"),
    },
    {
      title: "手机号",
      dataIndex: "phonenumber",
      key: "phonenumber",
    },
    {
      title: "证件类型",
      dataIndex: "baseUserIdCategory",
      key: "baseUserIdCategory",
      render: (text, record, index) =>
        record.baseUserIdCategory === "0" ? "身份证" : "其他",
    },
    {
      title: "身份证号",
      dataIndex: "identityNumber",
      key: "identityNumber",
    },
    {
      title: "工作单位",
      dataIndex: "workUnit",
      key: "workUnit",
    },
    {
      title: "操作",
      render: (record, value: any) => (
        <Space>
          <Button
            type="link"
            onClick={() => {
              setAddCountyAdmin(true);
              setIsAddAdminUser(false);
              form2.setFieldsValue({
                ...record,
              });
              setAdminUserInfo(record);
            }}
          >
            编辑
          </Button>
          <Divider type="vertical" />
          <Button onClick={() => deleteUserAdmin(value.userId)} type="link">
            删除
          </Button>
          <Divider type="vertical" />
          <Button onClick={() => resetUserPasword(value.userId)} type="link">
            重置密码
          </Button>
        </Space>
      ),
    },
  ];
  const getAll = async (page = 1, param = "") => {
    const { rows, total } = await getAdminManageData(1, param);
    setTableTotal(total);
    setDataSource(rows);
  };

  useEffect(() => {
    getAll();
  }, []);
  const setTimeCancel = useCallback((e: any) => {
    setAddCountyAdmin(false);
  }, []);

  const onFinish = async (value: any) => {
    let str = objectFormatStr(value);
    await getAll(1, str);
  };
  const addCountyAdminFinish = async (value: any) => {
    const { userId } = adminUserInfo;
    if (value.phonenumber && isAddAminUser) {
      value.userName = value.phonenumber;
    }
    // 信息新增
    if (isAddAminUser) {
      await queryAddCountyAdmin(value);
    } else {
      // 查找更改的值
      let diffValue = {};
      for (let key in value) {
        if (value[key] !== adminUserInfo[key]) {
          // @ts-ignore
          diffValue[key] = value[key];
        }
      }
      await queryUpdateCountyAdmin({
        userId,
        ...diffValue,
      });
    }
    setAddCountyAdmin(false);
    getAll(1);
  };
  const onFinishFailed = useCallback(() => {
    console.log("onFinishFailed验证未通过");
  }, []);
  const onReset = () => {
    form1.resetFields();
    getAll(1);
  };
  /**
   * 下载用户导入模版
   */
  const downLoadTemplate = async () => {
    const { rows } = await getAdminTemplate();
    const { exceltemplateaddress } = rows[0];
    window.location.href = exceltemplateaddress;
  };
  return (
    <div>
      {mainFlag === "0" && (
        <div>
          <Form
            name="provinceSet"
            initialValues={{ remember: true }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            form={form1}
            wrapperCol={{ span: 16 }}
          >
            <Row>
              <Col span={6}>
                <Form.Item label="姓名" name="nickName">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="身份证件号码" name="identityNumber">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item label="手机号" name="phonenumber">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Button type="primary" htmlType="submit">
                  查询
                </Button>
                <Button
                  type="primary"
                  onClick={onReset}
                  style={{ marginLeft: "15px" }}
                >
                  重置
                </Button>
              </Col>
            </Row>
          </Form>
          <div>
            <Space>
              <Button
                onClick={() => {
                  setAddCountyAdmin(true);
                  setIsAddAdminUser(true);
                }}
              >
                添加
              </Button>
              <Upload
                maxCount={1}
                accept=".xlsx"
                showUploadList={false}
                onRemove={(file) => {
                  const index = fileList.indexOf(file);
                  const newFileList = fileList.slice();
                  newFileList.splice(index, 1);
                  setFileList(newFileList);
                }}
                beforeUpload={(file) => {
                  console.log(file);
                  if (file.size > 307200) {
                    message.error("文件不可大于300K");
                    return;
                  }
                  const formData = new FormData();
                  formData.append("file", file);
                  setFileList([...fileList, file]);
                  const {
                    userInfo: { access_token },
                  } = store.getState();
                  const config = {
                    headers: {
                      "Content-Type": "multipart/form-data",
                      Authorization: `Bearer ${access_token}`,
                    },
                  };
                  axios
                    .post(
                      `${prefixpath}/dev-api/system/user/admin/importData?updateSupport=${false}`,
                      formData,
                      config
                    )
                    .then(
                      (res: any) => {
                        console.log(res);
                        if (res.data.code === 200) {
                          message.success({
                            content: `${res.data.msg}`
                              .split("<br/>")
                              .join("\n"),
                            style: { whiteSpace: "pre-wrap" },
                          });
                          getAll();
                        } else {
                          message.error({
                            content: `${res.data.msg}`
                              .split("<br/>")
                              .join("\n"),
                            style: { whiteSpace: "pre-wrap" },
                          });
                        }
                      },
                      (err) => {
                        message.error(`${err}`);
                      }
                    );
                  return false;
                }}
              >
                <Button type="primary" icon={<UploadOutlined />}>
                  导入
                </Button>
              </Upload>
              <Button onClick={downLoadTemplate}>下载模版</Button>
              <span style={{ color: "red" }}>
                提示:管理员账号用户名为手机号，初始密码为手机号后6位
              </span>
            </Space>
          </div>
          <Table
            dataSource={dataSource}
            columns={columns}
            style={{
              marginTop: "20px",
            }}
            pagination={{
              pageSize: 10,
              total: tableTotal,
              onChange: (page) => {
                getAll(page);
              },
              showTotal: (total) => {
                return "共" + total + "条记录";
              },
            }}
          />
          <Modal
            title={`${isAddAminUser ? "添加" : "编辑"}县医院管理员`}
            visible={addCountyAdmin}
            onCancel={setTimeCancel}
            footer={[]}
            width="650px"
            destroyOnClose={true}
          >
            <Form
              name="provinceSet"
              onFinish={addCountyAdminFinish}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              form={form2}
              style={{
                width: "240px",
              }}
              preserve={false}
            >
              <Form.Item
                label="管理员姓名"
                name="nickName"
                rules={[{ required: true, message: "请填写管理员姓名" }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="证件类型"
                name="baseUserIdCategory"
                rules={[{ required: true, message: "请选择证件类型" }]}
              >
                <Select style={{ width: "200px" }}>
                  <Option value="0">身份证</Option>
                  <Option value="1">其他</Option>
                </Select>
              </Form.Item>
              <Form.Item
                label="身份证号码"
                name="identityNumber"
                rules={[{ required: true, message: "请填写身份证号码" }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                label="性别"
                name="sex"
                rules={[{ required: true, message: "请选择性别" }]}
              >
                <Select style={{ width: "200px" }}>
                  <Option value="0">男</Option>
                  <Option value="1">女</Option>
                </Select>
              </Form.Item>
              <Form.Item
                label="手机号"
                name="phonenumber"
                rules={[{ required: true, message: "请填写手机号" }]}
              >
                <Input disabled={!isAddAminUser} />
              </Form.Item>
              <Form.Item
                label="工作单位"
                name="workUnit"
                rules={[{ required: true, message: "请填写工作单位" }]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                style={{
                  display: "flex",
                  marginTop: "15px",
                  width: "100%",
                  justifyContent: "center",
                }}
              >
                <Button onClick={setTimeCancel} style={{ marginRight: "15px" }}>
                  取消
                </Button>
                <Button type="primary" htmlType="submit">
                  保存
                </Button>
              </Form.Item>
            </Form>
          </Modal>
        </div>
      )}
      {mainFlag === "2" && <Result title="此账号不是主账号，暂无权限" />}
    </div>
  );
}
